import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import type { Document } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import RichText from '@segment/matcha/recipes/RichText'

import manageYourRiskExposurePng2x from './assets/ManageYourRiskExposure@2x.png'
import manageYourRiskExposureWebp from './assets/ManageYourRiskExposure.webp'
import manageYourRiskExposureWebp2x from './assets/ManageYourRiskExposure@2x.webp'
import manageYourRiskExposureWebp3x from './assets/ManageYourRiskExposure@3x.webp'

const copy = {
  overline: `Privacy Controls`,
  heading: `Manage your risk exposure`,
}

const description = {
  content: [
    {
      content: [
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `Don’t want your team collecting passwords or credit card numbers? Segment makes it easy to proactively enforce your company’s data privacy policies.`,
        },
      ],
      data: {},
      nodeType: BLOCKS.PARAGRAPH,
    },
    {
      content: [
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `Set rules to automatically block restricted personal data from being collected.`,
        },
      ],
      data: {},
      nodeType: BLOCKS.PARAGRAPH,
    },
  ],
  data: {},
  nodeType: BLOCKS.DOCUMENT,
} as Document

const ManageYourRiskExposure: FC<PropsWithChildren<unknown>> = () => {
  return (
    <SectionBase variant="2Col" copyVariant="narrow">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <RichText data={description} />
        </CopyTextBase>
      </Section.Copy>
      <SectionContents>
        <picture>
          <source
            type="image/webp"
            srcSet={`${manageYourRiskExposureWebp}, ${manageYourRiskExposureWebp2x} 2x, ${manageYourRiskExposureWebp3x} 3x`}
          />
          <Image
            width="640"
            height="560"
            src={manageYourRiskExposurePng2x}
            alt="Illustration: Manage your risk exposure"
            loading="lazy"
          />
        </picture>
      </SectionContents>
    </SectionBase>
  )
}

const SectionContents = styled(Section.Contents)`
  justify-content: center;
  align-self: center;
  display: flex;
`

export default ManageYourRiskExposure
